import { render, staticRenderFns } from "./PremiumSurveyStartPage.vue?vue&type=template&id=273ea16c&scoped=true"
import script from "./PremiumSurveyStartPage.vue?vue&type=script&lang=js"
export * from "./PremiumSurveyStartPage.vue?vue&type=script&lang=js"
import style0 from "./PremiumSurveyStartPage.vue?vue&type=style&index=0&id=273ea16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ea16c",
  null
  
)

export default component.exports